import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { serviceRequestFeature, ServiceRequestEffects } from './store';

export function provideServiceRequestFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(serviceRequestFeature),
    provideEffects(ServiceRequestEffects),
  ]);
}
